import {
    CTRL_CHANGE_PASSWORD,
    CTRL_GET_PROFILE,
    CTRL_UPDATE_PROFILE,
} from '../../../actions/index.types';


export function getProfile(data) {
    return {
        type: CTRL_GET_PROFILE,
        data
    }
}
export function updateProfile(data) {
    return {
        type: CTRL_UPDATE_PROFILE,
        data
    }
}

export function changePassword(data) {
    return {
        type: CTRL_CHANGE_PASSWORD,
        data
    }
}
